import { getToken } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { CLINICS } from '../../constant';

/** Per-clinic alert settings (overdue threshold days, alert hour, enabled). Admin only. */
export const getAlertSettings = createAsyncThunk(
  'clinic/getAlertSettings',
  async (_: void, { rejectWithValue }) => {
    try {
      const res = await fetch(CLINICS.ALERT_SETTINGS_URL, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + getToken(),
        },
      });
      if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        return rejectWithValue(errorData.msg || 'Failed to fetch alert settings');
      }
      return await res.json();
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
